import { sanitizedMsg } from "../../../utils/htmlUtils";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from "react";


export default function TooltipDiv(
    {
        Div,
        info,
    }
) {

    return (
        <>
            {info ? (
                <OverlayTrigger
                    placement={ 'top' }
                    // delay={{ show: 100, hide: 150 }}
                    trigger={['hover', 'focus', 'click']}
                    overlay={
                        <Tooltip>
                            <span dangerouslySetInnerHTML={ sanitizedMsg(info) }/>
                        </Tooltip>
                    }
                >
                    { Div }
                </OverlayTrigger>
            ) : (
                { Div }
            ) }
        </>
    )
}